import { render, staticRenderFns } from "./items-counter.vue?vue&type=template&id=d09451c2&scoped=true"
import script from "./items-counter.vue?vue&type=script&lang=js"
export * from "./items-counter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d09451c2",
  null
  
)

export default component.exports